module.exports = __webpack_public_path__ + "static/media/bus-school.aee5de35.svg";